import { Injectable } from '@angular/core';
import { SubHeaderService } from '../../store/subheader/subheader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ExportService } from '../../store/export/export.service';
import { combineLatest, debounceTime, filter } from 'rxjs';
import { PaginationService } from '../../store/pagination/pagination.service';
import { SearchService } from '../../store/search/search.service';
import { Router } from '@angular/router';
import { ViewService } from '../../store/view/views.service';
import { take } from 'rxjs/operators';
import { FileModel } from '../../store/export/types';
import { ConfigurationService } from '../configuration.service';
import { FileSaverService } from 'ngx-filesaver';
import { base64ToBlob } from '../../helper/base64helper';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ExportDataService {
  downloadClicked: boolean = false;

  constructor(
    private readonly exportService: ExportService,
    private readonly subHeaderService: SubHeaderService,
    private readonly paginationService: PaginationService,
    private readonly searchService: SearchService,
    private readonly viewService: ViewService,
    private readonly configurationService: ConfigurationService,
    private readonly fileSaverService: FileSaverService,
  ) {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'exportData') this.exportData();

        this.subHeaderService.setTriggerAction('');
      });
  }

  private exportData() {
    this.exportService.exportToCsv.reset();
    if (this.downloadClicked) return;

    this.downloadClicked = true;

    const getFileSubscription = this.exportService.exportToCsv.value$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((result: FileModel) => {
        const blob = base64ToBlob(result.data, result.contentType);
        if (
          this.configurationService
            .getOpenFileExtensions()
            .some((x) => x.includes(result.contentType))
        ) {
          var fileURL = window.URL.createObjectURL(blob);
          let tab = window.open();
          if (tab) {
            tab.location.href = fileURL;
          }
        } else {
          this.fileSaverService.save(blob, result.name, result.contentType);
        }
        this.downloadClicked = false;
        this.exportService.exportToCsv.reset();
      });

    combineLatest([
      this.viewService.getViews.value$,
      this.searchService.getActiveFilters(),
      this.paginationService.getPageIndex(),
      this.paginationService.getPageSize(),
      this.paginationService.getSortBy(),
      this.paginationService.getOrderBy(),
    ])
      .pipe(
        filter(
          ([view, activeFilter, pageIndex, pageSize, sortBy, orderBy]) =>
            !!view &&
            !!activeFilter &&
            !!pageIndex &&
            !!pageSize &&
            !!sortBy &&
            !!orderBy,
        ),
        debounceTime(200),
        take(1),
      )
      .subscribe(
        ([view, activeFilters, pageIndex, pageSize, sortBy, orderBy]) => {
          this.exportService.exportToCsv.call({
            filters: activeFilters,
            url: view.searchView.url,
            pageIndex: pageIndex,
            pageSize: pageSize,
            sortBy: sortBy,
            orderBy: orderBy,
          });
        },
      );
  }
}
